<template>
  <div class="test">
    <div class="dd_wrapper">
      <div class="my_header border">
        <div class="face border"></div>
        <div class="eye_wrapper">
          <div class="eye border"></div>
          <div class="eye border"></div>
        </div>
        <div class="nose border"></div>
        <div class="mouth border">
          <div class="shetou border"></div>
        </div>
        <ul class="beard">
          <li class="beard_item"></li>
          <li class="beard_item"></li>
          <li class="beard_item"></li>
          <li class="beard_item"></li>
          <li class="beard_item"></li>
          <li class="beard_item"></li>
        </ul>
      </div>
      <div class="my_body"></div>
      <div class="my_foot"></div>
    </div>
  <div>
    <el-upload
      class="avatar-uploader"
      action="http://school.duzhitech.cn/api/Upload"
      :http-request="uploadFile"
      :show-file-list="false"
      :headers="headers"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
  </div>

</template>

<script lang="ts">
import { ElMessage } from 'element-plus'
import { defineComponent, reactive, toRefs } from 'vue';
// import {uploadApi} from '../api/upload';
import axios from "axios";
export default defineComponent({
  name: "login",
  setup(){
      console.log(process.env);
      const rawData = reactive({
        imageUrl:'',
        headers: {"content-type": "multipart/form-data"}
      })
      function handleAvatarSuccess(res : any, file : any) {
        rawData.imageUrl = URL.createObjectURL(file.raw);
      }
      function beforeAvatarUpload(file : any) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          ElMessage.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          ElMessage.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      }

      function uploadFile(item:any) {
        let file = item.file;
        const form = new FormData(); // FormData 对象
        form.append("files", file); // 文件对象  'upload'是后台接收的参数名
        //有qs这个格式化不行
        // uploadApi(form).then(res=>{
        //   console.log(res);
        // })
        //如果用了qs，这里就需要统一处理成
        axios.post('http://school.duzhitech.cn/api/Upload',form,{
          headers: {"content-type": "multipart/form-data"}
        }).then(res=>{
          if(res.data && res.data.state === 0){
            rawData.imageUrl = process.env.VUE_APP_BASE_URL as string + res.data.content
          }
        })
      }



      return {...toRefs(rawData),
      handleAvatarSuccess,beforeAvatarUpload,uploadFile
      }

  }
})
</script>

<style lang="scss">
  li{list-style: none;}
.test{
  width: 1000px; height: 100vh;  margin: 0 auto; border:1px solid #ccc;
    .dd_wrapper{position: relative; width: 300px; margin: 0 auto;
      .border{border:2px solid #333}
      .my_header{ position: relative;
        background: rgb(42, 134, 255); width: 200px; height: 200px; border-radius: 50%; z-index: 1;
        .face{
          background: #fff; width: 160px; position: absolute; height: 160px; border-radius: 50%; bottom:0; left: 19px; z-index: 2;
        }
        .eye_wrapper{position: absolute; z-index: 3; display: flex; width: 80px; top: 20px; left: 60px;
          .eye{width: 40px; height: 40px; border-radius: 50%; background: #fff; flex: 1;}
        }
        .nose{
          background: red; position: absolute; z-index: 4; width: 30px; height: 30px; top: 57px; left: 83px; border-radius: 50%;
        }
        .mouth{
          background: saddlebrown; width: 120px; height: 60px; border-radius: 0 0 100px 100px; position: absolute;
          z-index: 4; bottom: 10px; left: 40px; overflow: hidden;
          .shetou{width: 40px; height: 40px; border-radius: 50%; margin: 40px auto; background: red;}
        }
        .beard{
          position: absolute; z-index: 5; width: 100px; display: flex; flex-wrap: wrap; top: 70px; left: 10px;
          .beard_item{
            height: 3px; background: #333; border-radius: 2px; margin: 5px; flex: 0 0 40%; 
          }
          // .beard_item:nth-child()
        }
      }
    }
}

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>